angular.module('impactx.download').controller('AttachmentRedirectCtrl', AttachmentRedirectCtrl);

AttachmentRedirectCtrl.$inject = ['dataGen', '$routeParams', '$window'];

function AttachmentRedirectCtrl(dataGen, $routeParams, $window)
{
    dataGen.getData({}, {baseUrl: $routeParams.baseUrl}, '/' + $routeParams.baseObject + '/view/attachmentlink');
    $window.location.replace($routeParams.baseUrl);
}
